export const idlFactory = ({ IDL }) => {
  const ConversionRecord = IDL.Record({
    'id' : IDL.Text,
    'fromAmount' : IDL.Float64,
    'timestamp' : IDL.Int,
    'conversionType' : IDL.Text,
    'toAmount' : IDL.Float64,
  });
  return IDL.Service({
    'addConversion' : IDL.Func(
        [IDL.Text, IDL.Float64, IDL.Float64, IDL.Text],
        [],
        [],
      ),
    'getConversions' : IDL.Func([], [IDL.Vec(ConversionRecord)], ['query']),
    'getCurrentSupply' : IDL.Func([], [IDL.Float64], []),
    'getSupplyChanges' : IDL.Func(
        [],
        [
          IDL.Record({
            'day' : IDL.Float64,
            'month' : IDL.Float64,
            'week' : IDL.Float64,
          }),
        ],
        ['query'],
      ),
    'getSupplyHistory' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Int, IDL.Float64))],
        ['query'],
      ),
  });
};
export const init = ({ IDL }) => { return []; };
